import { useState, useEffect, useMemo, type ReactNode } from "react";
import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
  CssBaseline,
  useMediaQuery,
} from "@mui/material";
import { ThemeContext, type ThemeMode } from "./ThemeContext";

export const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  // Initialize from localStorage or default to 'system'
  const [mode, setMode] = useState<ThemeMode>(() => {
    const savedMode = localStorage.getItem("themeMode");
    return (savedMode as ThemeMode) || "system";
  });

  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

  useEffect(() => {
    localStorage.setItem("themeMode", mode);
  }, [mode]);

  const theme = useMemo(() => {
    let activeMode: "light" | "dark";
    if (mode === "system") {
      activeMode = prefersDarkMode ? "dark" : "light";
    } else {
      activeMode = mode;
    }

    return createTheme({
      palette: {
        mode: activeMode,
      },
    });
  }, [mode, prefersDarkMode]);

  const contextValue = useMemo(() => ({ mode, setMode }), [mode]);

  return (
    <ThemeContext.Provider value={contextValue}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};
